import React from "react";
import { FaFacebookF, FaInstagram } from "react-icons/fa"; // Import icons
import "./Footer.css";

const Footer = () => (
  <footer className="footer text-center py-5">
    <div className="mb-3">
      <img
        src="logo/Logo-F1-OP.png"
        alt="Impcaterer Logo"
        height="150"
        className="footer-logo"
      />
    </div>
    <div className="social-links mb-3">
      <a href="https://www.facebook.com/p/%E5%BE%A1%E8%86%B3%E6%88%BF-Imperial-Caterer-100088595277892/" target="_blank" rel="noopener noreferrer">
        <FaFacebookF className="social-icon" />
      </a>
      {/* <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer">
        <FaInstagram className="social-icon" />
      </a> */}
    </div>
    <p className="mb-0">&copy; 2025 Imperial Caterer. All rights reserved.</p>
  </footer>
);

export default Footer;